import React from 'react';
import {PlaceApi} from "../../../../../../services/Api/types";
import MultistorePlaceCardCover from "./MultistorePlaceCardCover";
import MultistorePlaceCardFooter from "./MultistorePlaceCardFooter";
import {useNavigate} from "react-router-dom";
import StorageStore from "../../../../../../services/Common/Storage/storageStore";

interface Props {
    place: PlaceApi;
}

const MultistorePlaceCard = ({place}: Props) => {
    const navigate = useNavigate();

    const getProperPlaceLink = () => {
        let link = place.domain.replace(`${StorageStore.storeDomain}/`, "/");

        if (!link.startsWith('/')) {
            link = '/' + link;
        }

        return link;
    }

    return (
        <div className="place-card" onClick={() => navigate(getProperPlaceLink())}>
            <MultistorePlaceCardCover place={place}/>
            <MultistorePlaceCardFooter place={place}/>
        </div>
    )
}

export default MultistorePlaceCard;